'use strict';

function titleCase(str) {
  return str.toLowerCase().replace(/\w\S*/g, function(txt) {
    return _.capitalize(txt);
  });
}

var filterModule = angular.module('filters', []);

filterModule.filter('addressAsString', function(OCAddressUtil) {
  return function(address) {
    return OCAddressUtil.addressAsString(address);
  };
});

filterModule.filter('capitalize', function() {
  return function(str) {
    if (str) {
      if (str.length > 1) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      } else {
        return str.toUpperCase();
      }
    }
  };
});

filterModule.filter('phone', function() {
  return function(input, hideExtension) {
    if (!input || input.length < 12 || (input.length > 12 && input.indexOf('x') == -1)) {
      return input;
    }
    if (hideExtension) {
      input = input.split('x')[0];
    }
    return input.replace(/^\+1/, '').replace(/^(.{3})(.{3})/, '($1) $2-')
      .replace('x', ' Ext. ');
  };
});

filterModule.filter('hiddenPhone', function() {
  return function(input) {
    if (!input || input.length < 12 || (input.length > 12 && input.indexOf('x') == -1)) {
      return input;
    }
    return input.replace(/^\+1/, '').replace(/^(.{3})(.{3})(.{2})/, '(***) *** - **')
      .replace('x', ' Ext. ');
  };
});

filterModule.filter('numberAsPeriodOfDaySubheading', function() {
  return function(input) {
    input = parseInt(input, 10);
    var periodSubheadings = [
      'Before 9:00 am',
      '9:00 am - 11:00 am',
      '11:00 am - 1:00 pm',
      '1:00 pm - 3:00 pm',
      '3:00 pm - 5:00 pm',
      'After 5:00 pm',
    ];
    return periodSubheadings[input];
  };
});

filterModule.filter('numberAsPeriodOfDayLabel', function() {
  return function(input) {
    input = parseInt(input, 10);
    var periodLabels = ['Early Morning', 'Morning', 'Lunch', 'Afternoon', 'Late Afternoon', 'Evening'];
    return periodLabels[input];
  };
});

filterModule.filter('numberAsDayOfWeek', function() {
  return function(input) {
    input = parseInt(input, 10);
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[input];
  };
});

filterModule.filter('numberAsMonth', function() {
  return function(monthNumber) { // 1 = January
    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return monthNames[monthNumber - 1];
  };
});

filterModule.filter('numberAsDayOfWeekInitial', function() {
  return function(input) {
    input = parseInt(input, 10);
    var days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    return days[input];
  };
});

filterModule.filter('minutesToTime', function() {
  return function(minutes) {
    return moment().startOf('year')
      .add(minutes, 'minutes')
      .format('h:mm a');
  };
});

filterModule.filter('momentUTCFormat', function() {
  return function(date, formatString) {
    if (!date) {
      return '';
    }
    return moment.utc(date).format(formatString);
  };
});

filterModule.filter('momentFormat', function() {
  return function(date, formatString) {
    if (!date) {
      return '';
    }
    return moment(date).format(formatString);
  };
});

filterModule.filter('genderAsWord', function() {
  return function(input) {
    var genderWords = {
      M: 'Male',
      F: 'Female',
      O: 'Other',
    };
    return genderWords[input];
  };
});

filterModule.filter('genderPreferenceDisplay', function(genderAsWordFilter) {
  return function(input) {
    if (!input) {
      return 'No preference';
    } else {
      return genderAsWordFilter(input);
    }
  };
});

filterModule.filter('howSoonPreferenceDisplay', function() {
  return function(input) {
    var valueToLabel = {
      ASAP: 'As soon as possible',
      '1 week': 'Within 1 week',
      '2 weeks': 'Within 2 weeks',
      'More than 2 weeks': 'In more than 2 weeks',
    };
    var label = valueToLabel[input];
    return label || input;
  };
});

filterModule.filter('lastVisitedDisplay', function() {
  return function(input) {
    if (input == 'Never') {
      return input;
    } else {
      return input + ' ago';
    }
  };
});

filterModule.filter('possessive', function() {
  return function(properNoun) {
    if (properNoun === null) {
      return properNoun;
    }
    if (properNoun.charAt(properNoun.length - 1) == 's' || properNoun.charAt(properNoun.length - 1) == 'S') {
      return properNoun + "'";
    } else {
      return properNoun + "'s";
    }
  };
});

filterModule.filter('appointmentSource', function() {
  return function(appointment) {
    switch (appointment.requestData.source) {
      case 'permalink':
        if (appointment.prime) {
          return 'Recommendation';
        }
        return "Clinic's Website";
      case 'clinic':
      case 'provider':
        return 'Profile Page';
      case 'city_specialty':
        return 'Top 10 Page';
      case 'discovery':
      case 'recommendations':
        return 'Recommendation';
      case 'oc_direct':
        return 'Opencare Chat';
      default:
        return 'Unknown';
    }
  };
});

filterModule.filter('appointmentBillingStatus', function(OpencareConstants) {
  return function(input) {
    switch (input) {
      case OpencareConstants.billingStates.TO_BILL:
        return 'Pending Charge';
      case OpencareConstants.billingStates.INVOICE_ISSUED:
        return 'Processing';
      case OpencareConstants.billingStates.NOT_BILLED:
      case OpencareConstants.billingStates.WRITE_OFF:
        return 'Not Billed';
      case OpencareConstants.billingStates.BILLED:
        return 'Billed';
      case OpencareConstants.billingStates.REFUNDED:
        return 'Refunded';
      case OpencareConstants.billingStates.TRIAL:
        return 'Free Trial';
      default:
        return 'Unknown';
    }
  };
});

filterModule.filter('titleCase', function() {
  return function(input) {
    return titleCase(input);
  };
});

filterModule.filter('appointmentStatus', function() {
  return function(input) {
    return titleCase(input.replace(/_/g, ' '));
  };
});

const getVerifyActor = (OpencareConstants, appointment) => {
  const isAutoReconciled = appointment.history.some(
    (historyItem) =>
      historyItem.actionType === OpencareConstants.appointmentHistory.actionTypes.APPT_RECONCILLED,
  );
  if (isAutoReconciled) {
    return 'Automatically';
  }

  // Admins ultimately decide if patient actually showed based on receipt
  const isVerifiedByAdmin = appointment.history.some(
    (historyItem) => historyItem.metadata?.adminVerified === true,
  );

  return isVerifiedByAdmin ? 'Automatically' : 'by Practice';
};

filterModule.filter('appointmentVerifiedActor', (OpencareConstants, OCAppointmentUtil) =>
  (appointment) => {
    if (appointment.status !== OpencareConstants.appointmentStates.COMPLETED) {
      return '—';
    }

    if (OCAppointmentUtil.isNoShow(appointment)) {
      return 'No Show';
    }

    if (!appointment.verified) {
      return 'Needs Verification';
    }

    const actor = getVerifyActor(OpencareConstants, appointment);

    return `Verified ${actor}`;
  });

filterModule.filter('boolYesNo', function() {
  return function(input) {
    return input ? 'Yes' : 'No';
  };
});

filterModule.filter('result', function() {
  return function(object, path, defaultValue) {
    return _.result(object, path, defaultValue);
  };
});

filterModule.filter('appointmentStatusAsAction', function() {
  return function(status) {
    var statusToAction = {
      CREATED: 'creating',
      REQUESTED: 'requesting',
      SCHEDULED: 'scheduling',
      COMPLETED: 'verifying',
      ARCHIVED: 'archiving',
      CANCELLED: 'cancelling',
      // Legacy statuses
      CANCELLED_BY_CLINIC: 'cancelling',
      CANCELLED_BY_PATIENT: 'cancelling',
      RESCHEDULED: 'scheduling',
      SCHEDULED_BY_CLINIC: 'scheduling',
      CONFIRMED: 'scheduling',
    };

    return statusToAction[status];
  };
});

filterModule.filter('join', function() {
  return function(list, seperator) {
    if (_.isEmpty(list)) {
      return '';
    }
    return list.join(seperator);
  };
});

filterModule.filter('reservedAppointmentSlotStatus', function() {
  return function(status) {
    return _.capitalize((status || '').toLowerCase());
  };
});

filterModule.filter('creditCard', function() {
  return function(last4) {
    return '●●●● ●●●● ●●●● ' + last4;
  };
});

filterModule.filter('bankAccount', function() {
  return function(last4) {
    return '●●●● ' + last4;
  };
});

filterModule.filter('percentage', function($filter) {
  return function(input, decimals) {
    return $filter('number')(input * 100, decimals) + '%';
  };
});

filterModule.filter('dateToAge', function() {
  return function(input) {
    return moment().diff(moment(input), 'years');
  };
});

filterModule.filter('coverageDetailPrice', function(OCUtil) {
  return function(input) {
    if (OCUtil.isNil(input)) {
      return 'Unknown';
    } else {
      return '$' + input;
    }
  };
});

filterModule.filter('coverageDetailPercent', function(OCUtil) {
  return function(input) {
    if (OCUtil.isNil(input)) {
      return 'Unknown';
    } else {
      return input + '%';
    }
  };
});

filterModule.filter('coverageDetailWaived', function(OCUtil) {
  return function(input) {
    if (OCUtil.isNil(input)) {
      return 'Unknown';
    } else {
      return input ? 'Waived' : 'Applied';
    }
  };
});

filterModule.filter('s3ImageUrl', function(OCPhotoUtil) {
  return function(imageData, size) {
    return OCPhotoUtil.getS3ImageUrl(imageData, size);
  };
});

filterModule.filter('insuranceS3Url', function(OCPhotoUtil) {
  return function(imageData) {
    return OCPhotoUtil.insurancePhotoUrl(imageData);
  };
});

filterModule.filter('paymentMethodLabel', function(OpencareConstants) {
  return function(paymentMethod) {
    let brand = paymentMethod.brand;
    let last4 = paymentMethod.last4;

    if (paymentMethod.stripeObject === OpencareConstants.paymentMethod.type.CARD) {
      brand ||= paymentMethod.metadata?.card?.brand;
      last4 ||= paymentMethod.metadata?.card?.last4;
      const expMonth = paymentMethod.expMonth || paymentMethod.metadata?.card?.expMonth;
      const expYear = paymentMethod.expYear || paymentMethod.metadata?.card?.expYear;

      return `${brand} •••• ${last4} exp. ${expMonth}/${expYear}`;
    } else if (paymentMethod.stripeObject === OpencareConstants.paymentMethod.type.BANK_ACCOUNT) {
      brand ||= paymentMethod.metadata?.bankAccount?.bank;
      last4 ||= paymentMethod.metadata?.bankAccount?.last4;

      return `${brand} •••• ${last4}`;
    }
  };
});

filterModule.filter('reverse', () =>
  (items) => items.slice().reverse());
